// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const SelectedClassProvider = registerClientReference(
    function() { throw new Error("Attempted to call SelectedClassProvider() from the server but SelectedClassProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/lib/context/SelectedClassContext.tsx",
    "SelectedClassProvider",
);
export const useSelectedClass = registerClientReference(
    function() { throw new Error("Attempted to call useSelectedClass() from the server but useSelectedClass is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/lib/context/SelectedClassContext.tsx",
    "useSelectedClass",
);
